import React from "react";
import data from "../json/Allproducts/XperttrackPPMS.json";
import Section1 from "../components/Allproducts/Section1";
import Section4 from "../components/Allproducts/Section4";


const Xperttrack = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">
      <Section1 data={data} />
      <Section4 data={data.Section4} />
    </div>
  );
};

export default Xperttrack;
